var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.06247 12.5C9.06247 9.22081 11.7208 6.5625 15 6.5625C18.2792 6.5625 20.9375 9.22081 20.9375 12.5C20.9375 15.7792 18.2792 18.4375 15 18.4375C11.7208 18.4375 9.06247 15.7792 9.06247 12.5ZM15 8.4375C12.7563 8.4375 10.9375 10.2563 10.9375 12.5C10.9375 14.7437 12.7563 16.5625 15 16.5625C17.2436 16.5625 19.0625 14.7437 19.0625 12.5C19.0625 10.2563 17.2436 8.4375 15 8.4375Z",
    fill: "#EB9F1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.40542 11.0711C4.84833 5.6978 9.33852 1.5625 14.73 1.5625H15.2699C20.6614 1.5625 25.1516 5.6978 25.5945 11.0711C25.8324 13.9575 24.9408 16.8236 23.1075 19.0657L17.1162 26.3929C16.0224 27.7306 13.9775 27.7306 12.8838 26.393L6.89242 19.0657C5.0591 16.8236 4.1675 13.9575 4.40542 11.0711ZM14.73 3.4375C10.3143 3.4375 6.63683 6.82435 6.27409 11.2251C6.07607 13.6274 6.81813 16.0128 8.34395 17.8788L14.3353 25.2061C14.6788 25.6262 15.3211 25.6262 15.6647 25.2061L21.656 17.8788C23.1818 16.0128 23.9239 13.6274 23.7259 11.2251C23.3631 6.82435 19.6856 3.4375 15.2699 3.4375H14.73Z",
    fill: "#EB9F1A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.be93b45c6cee7088e34c680d10ee398b.svg";
export { ForwardRef as ReactComponent };